export class Size {

  public static readonly EXTRA_SMALL = new Size('xs');
  public static readonly SMALL = new Size('sm');
  public static readonly LARGE = new Size('lg');
  public static readonly SEARCH_FILTER = new Size('search-filter');
  public static readonly AUTO = new Size('auto');

  public readonly value: 'sm' | 'lg' | 'xs' | 'search-filter' | 'auto';

  private constructor(size: any) {
    this.value = size;
  }

  public isSmall(): boolean {
    return this.value === 'sm';
  }

  public isLarge(): boolean {
    return this.value === 'lg';
  }

  public isAuto(): boolean {
    return this.value === 'auto';
  }
}
